import groupBy from 'lodash/groupBy';
import map from 'lodash/map';
import sortBy from 'lodash/sortBy';

import { plural } from '../../../../shared/helpers/plural';
import type { AnnotatedLicense } from '../../../types';

// todo: these should be followed, but the current design doesn't really account for them.
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */

type LicensePanelProps = {
  loading: boolean;
  licenses: AnnotatedLicense[];
  onSelectLicense: (licenseId: string) => void;
};

function describeDepth(depth: string): string {
  switch (depth) {
    case '0':
      return 'Directly in Code';
    case '1':
      return 'Starting in Direct Dependencies';
    default:
      return `Starting From ${depth}-Level Deep Dependencies`;
  }
}

function licenseNameStyle(name: string) {
  if (name.includes('GPL')) {
    return { borderLeft: 'solid 2px red' };
  }
  return {};
}

type LicensePanelItemProps = {
  license: AnnotatedLicense;
  onSelectLicense: (licenseId: string) => void;
};

const LicensePanelItem = ({ license, onSelectLicense }: LicensePanelItemProps) => (
  <li
    onClick={() => onSelectLicense(license.licenseId)}
    style={licenseNameStyle(license.name)}
  >
    <span>{license.name}</span>
  </li>
);

/**
 * This is a MVP replacement for the LicensePanel that is used on the Projects->Licenses page,
 * that supports the concept of multiple projects.
 * At this time, this replacement panel does not support the following features:
 * - Hiding licenses that are ignored
 * - Adding / Removing licenses to the ignore list
 * - Adding / Removing manual licenses
 * - Warning users about browsing access depth
 */
export const LicensePanel = (props: LicensePanelProps) => {
  const { licenses = [] } = props;
  const depthGroups = groupBy(licenses, (license) => license.depth);

  return (
    <div className="panel">
      <div className="panel-header padded padded-small">
        <h3 style={{ display: 'inline-block', marginTop: 0 }}>
          <b>{licenses.length} {plural(licenses.length, 'License')} Found</b>
        </h3>
      </div>
      <ul className="panel-list">
        {map(depthGroups, (group: AnnotatedLicense[], depth: string) => ([
          <li key="header" className="header">
            {describeDepth(depth)}
          </li>,
          map(sortBy(group, (license) => license.licenseId.toLocaleLowerCase()), (license, i) => (
            <LicensePanelItem
              key={i}
              onSelectLicense={props.onSelectLicense}
              license={license}
            />
          )),
        ]))}
      </ul>
    </div>
  );
};

export default LicensePanel;
